module.exports = __webpack_public_path__ + "static/media/b1.9eb2ba9e.png";